import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import ChartableMixin from "../../../../lib/ModelMixins/ChartableMixin";
import StubCatalogItem from "../../../../lib/Models/Catalog/CatalogItems/StubCatalogItem";
import CreateModel from "../../../../lib/Models/Definition/CreateModel";
import TerriaFeature from "../../../../lib/Models/Feature/Feature";
import Terria from "../../../../lib/Models/Terria";
import ChartExpandAndDownloadButtons from "../../../../lib/ReactViews/Custom/Chart/ChartExpandAndDownloadButtons";
import Chart from "../../../../lib/ReactViews/Custom/Chart/FeatureInfoPanelChart";
import ChartCustomComponent from "../../../../lib/ReactViews/Custom/ChartCustomComponent";
import mixTraits from "../../../../lib/Traits/mixTraits";
import MappableTraits from "../../../../lib/Traits/TraitsClasses/MappableTraits";
import UrlTraits from "../../../../lib/Traits/TraitsClasses/UrlTraits";
describe("ChartCustomComponent", function () {
  let terria;
  beforeEach(function () {
    terria = new Terria({
      baseUrl: "./"
    });
  });
  it("correctly creates the chart", () => {
    const component = new TestChartCustomComponent();
    const context = {
      terria: terria,
      catalogItem: new StubCatalogItem(undefined, terria, undefined),
      feature: new TerriaFeature({})
    };
    const node = {
      name: component.name,
      attribs: {
        data: '[["x","y","z"],[1,10,3],[2,15,9],[3,8,12],[5,25,4]]'
      }
    };
    const chart = component.processNode(context, node, [], 0);
    expect(chart).toBeDefined();
    expect(chart === null || chart === void 0 ? void 0 : chart.key).toContain("chart-wrapper");
    expect(chart === null || chart === void 0 ? void 0 : chart.type).toBe("div");
    expect(chart === null || chart === void 0 ? void 0 : chart.props.children).toBeDefined();
    expect((chart === null || chart === void 0 ? void 0 : chart.props.children[0].type) === ChartExpandAndDownloadButtons).toBeTruthy();
    expect((chart === null || chart === void 0 ? void 0 : chart.props.children[1].type) === Chart).toBeTruthy();
  });
  it("creates shareable chart items for the expand menu", function () {
    const TestComponentWithShareableChartItem = class TestComponentWithShareableChartItem extends TestChartCustomComponent {
      constructor() {
        super(...arguments);
        _defineProperty(this, "constructShareableCatalogItem", (_id, context, _sourceReference) => this.createItemReference(context.catalogItem));
      }
    };
    const component = new TestComponentWithShareableChartItem();
    const context = {
      terria: terria,
      catalogItem: new StubCatalogItem("parent", terria, undefined),
      feature: new TerriaFeature({})
    };
    const node = {
      name: component.name,
      attribs: {
        title: "Foo",
        data: '[["x","y","z"],[1,10,3],[2,15,9],[3,8,12],[5,25,4]]',
        sources: "a, b"
      }
    };
    spyOn(component, "constructShareableCatalogItem").and.callThrough();
    component.processNode(context, node, [], 0);
    expect(component.constructShareableCatalogItem).toHaveBeenCalledTimes(2);
    // Make sure the id is dependent on parent, title & source name
    expect(component.constructShareableCatalogItem).toHaveBeenCalledWith("parent:Foo:a", jasmine.any(Object), undefined);
  });
});
class TestChartCustomComponent extends ChartCustomComponent {
  get name() {
    return "test";
  }
  constructCatalogItem(id, context, _sourceReference) {
    return context.terria ? new TestCatalogItem(id, context.terria, undefined) : undefined;
  }
  setTraitsFromAttrs(_item, _attrs, _sourceIndex) {
    return;
  }
}
class TestCatalogItem extends ChartableMixin(CreateModel(mixTraits(UrlTraits, MappableTraits))) {
  get mapItems() {
    return [];
  }
  forceLoadMapItems() {
    return Promise.resolve();
  }
  get chartItems() {
    return [{
      item: {},
      id: "zzz",
      name: "zzz",
      categoryName: "ZZZ",
      key: "key-zzz",
      type: "line",
      xAxis: {
        name: "Time",
        scale: "time"
      },
      points: [{
        x: 10,
        y: 10
      }],
      domain: {
        x: [0, 100],
        y: [0, 50]
      },
      units: "time",
      isSelectedInWorkbench: true,
      showInChartPanel: true,
      updateIsSelectedInWorkbench: () => {},
      getColor: () => "#fff",
      pointOnMap: {
        latitude: -33.8688,
        longitude: 151.2093
      }
    }, {
      item: {},
      id: "aaa",
      name: "aaa",
      categoryName: "AAA",
      key: "key-aaa",
      type: "line",
      xAxis: {
        name: "Time",
        scale: "time"
      },
      points: [{
        x: 10,
        y: 10
      }],
      domain: {
        x: [0, 100],
        y: [0, 50]
      },
      units: "time",
      isSelectedInWorkbench: true,
      showInChartPanel: true,
      updateIsSelectedInWorkbench: () => {},
      getColor: () => "#fff",
      pointOnMap: {
        latitude: -37.814,
        longitude: 144.96332
      }
    }];
  }
}